<template>
  <article class="auction-order">
    <group class="auction-manage fn-red" :title="keyToValue(match_order.match_order_status, orderStatus)" >
      <cell :title="auction_info.car_model_name" :bdStart="bdStart" class="v-primary-lh">
        <div slot="after-title" class="vux-label-desc mt">{{auction_info.vin}}</div>
        <div class="service-icon" slot="icon">
          <img :src="auction_info.car_image">
        </div>
      </cell>

      <div class="button-auction-inquiry">
        <div class="button-auction-info" @click="toAuctionInquiry('/auction/manage', auction_info.auction_car_id)">
          <i class="icon icon-auction" />
          <span class="text">拍卖信息</span>
        </div>
        <div v-if="seeEnquiryAuth" class="button-inquiry-info" @click="toAuctionInquiry('/inquiry/inquiryList/inquirys', auction_info.auction_car_id)">
          <i class="icon icon-inquiry" />
          <span class="text">询价信息</span>
        </div>
      </div>

      <cell class="no-top-border">
        <div slot="after-title">
          <flexbox class="flexbox">
            <flexbox-item :span="180/690" class="key">订单编号</flexbox-item>
            <flexbox-item class="value">{{match_order.order_id}}
            </flexbox-item>
          </flexbox>
          <flexbox class="flexbox">
            <flexbox-item :span="180/690" class="key">撮合价格</flexbox-item>
            <flexbox-item class="value">{{match_order.match_price | getPrice}}</flexbox-item>
          </flexbox>
          <flexbox class="flexbox" v-if="match_order.match_order_status === 2">
            <flexbox-item :span="180/690" class="key">实收金额</flexbox-item>
            <flexbox-item class="value">{{match_order.actual_paid_amount | getPrice}}</flexbox-item>
          </flexbox>
          <flexbox class="flexbox">
            <flexbox-item :span="180/690" class="key">收车实价</flexbox-item>
            <flexbox-item class="value">{{auction_info.purchase_price | getPrice}}</flexbox-item>
          </flexbox>
          <flexbox class="flexbox">
            <flexbox-item :span="180/690" class="key">毛利率</flexbox-item>
            <flexbox-item class="value">{{match_order.gross_profit_rate ? match_order.gross_profit_rate : '--'}}</flexbox-item>
          </flexbox>
          <flexbox class="flexbox" v-if="this.channel === 5">
            <flexbox-item :span="180/690" class="key">线索来源</flexbox-item>
            <flexbox-item class="value">寄售</flexbox-item>
          </flexbox>
        </div>
      </cell>
      <!-- 已成交，经销商选择已付款时-->
      <cell v-if="match_order.match_order_status === 2">
        <div slot="after-title">
          <flexbox class="flexbox">
            <flexbox-item :span="180/690" class="key">收款时间</flexbox-item>
            <flexbox-item class="value">{{match_order.paid_date}}
            </flexbox-item>
          </flexbox>
          <flexbox class="flexbox">
            <flexbox-item :span="180/690" class="key">备注信息</flexbox-item>
            <flexbox-item class="value">{{match_order.paid_note}}</flexbox-item>
          </flexbox>
        </div>
      </cell>
    </group>
    <group class="auction-manage"  title="买家信息" >
      <cell :title="winner_info.name" class="winner-info">
        <a slot="after-title" class="mt" @click="phoneCall()">{{winner_info.mobile}}</a>
      </cell>
      <cell>
        <div slot="after-title">
          <flexbox class="flexbox">
            <flexbox-item :span="180/690" class="key">加入时间</flexbox-item>
            <flexbox-item class="value">{{winner_info.created_at}}</flexbox-item>
          </flexbox>
          <flexbox class="flexbox">
            <flexbox-item :span="180/690" class="key">车商类型</flexbox-item>
            <flexbox-item class="value">{{winner_info.organization_type}}</flexbox-item>
          </flexbox>
          <flexbox class="flexbox">
            <flexbox-item :span="180/690" class="key">车商名称</flexbox-item>
            <flexbox-item class="value">{{winner_info.organization_name}}</flexbox-item>
          </flexbox>
          <flexbox class="flexbox">
            <flexbox-item :span="180/690" class="key">法人</flexbox-item>
            <flexbox-item class="value">{{winner_info.legal_person_name}}</flexbox-item>
          </flexbox>
        </div>
      </cell>
      <cell>
        <div slot="after-title">
          <flexbox class="flexbox">
          <flexbox-item :span="180/690" class="key">所在地区</flexbox-item>
          <flexbox-item class="value">{{winner_info.province}}{{winner_info.city}}</flexbox-item>
          </flexbox>
          <flexbox class="flexbox">
          <flexbox-item :span="180/690" class="key">具体地址</flexbox-item>
          <flexbox-item class="value">{{winner_info.address}}</flexbox-item>
          </flexbox>
        </div>
      </cell>
    </group>
    <!-- 已成交和以收款显示todo -->
    <div v-if="isReviewed">
      <div class="rate_list_title">评价信息</div>
      <rate-detail
        :review_type="review_info.review_type"
        :reviewer="review_info.reviewer"
        :content="review_info.content"
        :transfer_speed="review_info.transfer_speed"
        :dealer_professional="review_info.dealer_professional"
        :payment_speed="review_info.payment_speed"
        :images="review_info.images"
        :date="review_info.date"
      >
      </rate-detail>
    </div>
    <footer-btn
      v-if="toReview && hasReviewAuth"
      title="去评价"
      @submit="toRate"
    ></footer-btn>
    <!--待收款-->
    <section class="btn-bottom submit-btn" v-if="match_order.match_order_status === 1">
      <div class="btn-fix">
        <a class="btn status" @click.stop="closeOrReject(match_order.order_id)">关闭</a>
        <a class="btn" @click.stop="paidOrReject(match_order.order_id)">已收款</a>
      </div>
    </section>
    <div class="auction-manage">
      <confirm title="是否确定关闭撮合订单？" cancelText="取消" confirmText="确定" v-model="showCloseConfirm" @on-confirm="onConfirm(match_order.order_id)">
        <p class="confirm-tip"></p>
      </confirm>
    </div>
  </article>
</template>
<script>
// 竞拍人详情
import { Cell, Group, Flexbox, FlexboxItem, Confirm } from '@lx-frontend/cvux'
import RateDetail from '../components/RateDetail'
import FooterBtn from '../components/FooterBtn'
export default {
  components: {
    Cell,
    Group,
    Flexbox,
    FlexboxItem,
    Confirm,
    RateDetail,
    FooterBtn
  },
  data() {
    return {
      isReviewed: false,
      toReview: false,
      hasReviewAuth: false,
      seeEnquiryAuth: false,
      bdStart: true,
      auction_info: {},
      match_order: {},
      winner_info: {},
      showCloseConfirm: false, // 关闭订单的弹窗
      orderStatus: [
        {
          key: 1,
          value: '待收款'
        },
        {
          key: 2,
          value: '已成交'
        },
        {
          key: 3,
          value: '已关闭'
        }
      ],
      orderType: '',
      channel: 0 // 判断是否为寄售
    }
  },
  created() {
    // 通过路由参数type 来区分是询价撮合订单详情还是流拍撮合订单详情；
    // type 为 enquiries 表示 询价撮合，原来为流拍撮合订单详情
    this.orderType = this.$route.query.type
    this.getOrder()
  },
  mounted() {
    this.$store.state.promiseAuth.then(auth => {
      this.hasReviewAuth = auth.authList.includes('used_car_review.review.write')
      // 查看询价信息权限
      this.seeEnquiryAuth = auth.authList.includes('used_car_car.enquiry.view')
    })
  },
  methods: {
    toRate() {
      const carInfo = {
        car_image_url: this.auction_info.car_image,
        car_model_name: this.auction_info.car_model_name,
        vin: this.auction_info.vin
      }
      this.$store.commit('UPDATE_AUCTION_INFO', carInfo)
      this.$router.push(`/usedcar/reviewSubmit/${this.auction_info.auction_car_id}`)
    },
    toAuctionInquiry(path, carId) {
      this.$router.push({
        path: path,
        query: {
          operation: 'search',
          searchType: 'auction_car_id',
          value: carId
        }
      })
    },
    /**
       * 获取订单详情 包含了 流拍撮合订单详情和询价撮合订单详情
       * 1、当 orderType为 enquiries 则调用询价撮合 其他 为 流拍撮合
       * 2、询价撮合和流拍撮合 返回的 data.enquiry_info 与 data.auction_info 对象名称不一样，所以动态赋值
       */
    getOrder () {
      let id = this.$route.params.id
      // 默认调用流拍撮合订单详情
      // 如果 orderType为 enquiries 则调用询价撮合
      let postMethod = this.orderType === 'enquiries' ? 'getEnquiryOrder' : 'getMatchOrder'
      if (id) {
        // 动态调用方法
        this.$rest.match[postMethod](null, id).then((res) => {
          if (res.code === 0) {
            let data = res.data
            if (data) {
              let info = {
                need_review_flag: data.need_review_flag,
                status: data.match_order.match_order_status
              }
              // 因为询价撮合和流拍撮合 auction_info 对象名称不一样，所以动态赋值
              this.auction_info = this.orderType === 'enquiries' ? data.enquiry_info : data.auction_info
              this.match_order = data.match_order
              this.winner_info = data.winner_info
              this.channel = (this.auction_info || {}).channel || 0
              return info
            }
          } else {
            this.showToast(res.message)
          }
        }).then(info => { // auction_car_id
          if (!info) return
          if (info.status !== 2) return // 订单是否完成
          if (info.need_review_flag === 1) { // 可以去评论
            this.toReview = true
          } else if (info.need_review_flag === 0) { // 已评论
            this.$rest.reviews.getReviewsDetail(null, this.auction_info.auction_car_id).then((res) => {
              if (res.code === 0) {
                let len = res.data.images.length
                if (len > 0) {
                  let arr = res.data.images.map(v => {
                    return { src: v }
                  })
                  res.data.images = arr
                }
                this.review_info = res.data
                this.isReviewed = true
              } else {
                this.showToast(res.message)
              }
            })
          }
        })
      }
    },
    phoneCall() {
      window.location.href = 'tel:' + this.winner_info.mobile
    },
    keyToValue(optionId, arr) {
      optionId = +optionId
      if (optionId) {
        let filterArray = arr.find(v => v.key === optionId)
        if (filterArray) {
          return filterArray.value
        }
      } else {
        return '--'
      }
    },
    /**
       * 确认订单关闭
       * 1、当 this.orderType为 enquiries 则调用询价撮合订单关闭 其他 为 流拍撮合订单关闭
       */
    onConfirm (id) {
      if (this.orderType === 'enquiries') {
        // 说明是询价撮合订单关闭
        this.$rest.match.putEnquiryCloseOrder(null, `${id}/order_close`).then(res => {
          if (res.code === 0) {
            // 刷新数据
            this.getOrder()
          } else {
            this.showToast(res.message)
          }
        })
      } else {
        this.$rest.match.putCloseOrder(null, id).then(res => {
          if (res.code === 0) {
            // 刷洗数据
            this.getOrder()
          } else {
            this.showToast(res.message)
          }
        })
      }
    },
    closeOrReject(orderId) {
      this.showCloseConfirm = true
    },
    /**
       * 收款功能 需要根据不同的orderType 增加不同的 路由参数，跳转到支付页面。
       * 路由参数 category 用于 区分 撮合订单确认收款提交
       * enquiries 询价撮合订单确认收款提交
       * auction 流拍撮合订单确认收款提交
       * match ： 用于区分是否为撮合订单收款提交
       */
    paidOrReject(orderId) {
      this.$router.push({
        path: '/auction/paid/' + orderId,
        query: {
          type: 'match',
          category: this.orderType === 'enquiries' ? 'enquiries' : 'auction',
          channel: this.channel
        }
      })
    }
  },
  computed: {},
  filters: {
    getStatus(status) {
      switch (status) {
        case 4:status = '待平台处理'
          break
        case 5:status = '已处理'
          break
        default:status = '--'
          break
      }
      return status
    },
    getPrice(price) {
      if (price) {
        price = (price / 100).toFixed(2) + '元'
      } else {
        price = '--'
      }
      return price
    }
  },
  watch: {
    auction_info (val) {
      const title = '订单收款确认'
      const desc = `${val.car_model_name} ${this.$route.query.plateNumber}`
      const imgUrl = val.car_image
      this.shareFriend({
        title,
        desc,
        imgUrl
      })
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less">
  @import "../../stylesheets/modules/manage/order.less";
  .rate_list_title{
  padding-top: 30/@w2;
  padding-left: 30/@w2;
  padding-right: 30/@w2;
  color: #000;
  font-size: 30/@w2;
  line-height: 60/@w2;
  opacity: 0.7;
}
.rater_accept_btn {
  margin: 50 / @w2 36 / @w2;
  button {
    width: 100%;
    height: 80 / @w2;
    line-height: 80 / @w2;
    font-size: 30 / @w2;
    text-align: center;
    border: 1px solid #ce3b28;
    color: #d24d3c;
    background-color: #fff;
    .radius(11 / @w2);
  }
}
</style>
